<template>
    <div class="content">
        <h1>KONTAKT</h1>
        <p>
            Hier können Sie mit mir Kontakt aufnehmen, indem Sie die Formular-Felder ausfüllen und mir Ihr Anliegen unterbreiten.
            Ich werde Ihnen zeitnah antworten, vielen Dank.
        </p>
        <div class="row">
            <div class="form-item col-md-6">
                <select
                    v-model="Contact.Title"
                    :class="[!Contact.Title ? 'form-error' : null, sendStateActive ? 'select-disabled' : null]"
                    :disabled="sendStateActive"
                    @change="updateContactStore()">
                    <option
                        v-for="option in title"
                        :value="option.value"
                        :key="option.value">
                        {{ option.text }}
                    </option>
                </select>
                <span class="form-label">&nbsp;Anrede</span>
            </div>
        </div>
        <div class="row">
            <div class="form-item col-md-6">
                <input
                    type="text"
                    v-model="Contact.FirstName"
                    :class="!Contact.FirstName ? 'form-error' : null"
                    :disabled="sendStateActive"
                    @input="updateContactStore()"
                    :placeholder="dataPlaceholder.FirstName">
            </div>
            <div class="form-item-right col-md-6">
                <input
                    type="text"
                    v-model="Contact.LastName"
                    :class="!Contact.LastName ? 'form-error' : null"
                    :disabled="sendStateActive"
                    @input="updateContactStore()"
                    :placeholder="dataPlaceholder.LastName">
            </div>
            <div class="form-item-right col-md-6">
                <input
                    type="email"
                    v-model="Contact.Email"
                    :class="!Contact.Email || !validateEmail(Contact.Email) ? 'form-error' : null"
                    :disabled="sendStateActive"
                    @input="updateContactStore()"
                    :placeholder="dataPlaceholder.Email">
            </div>
            <div class="form-item form-item-message col-md-12">
                Bitte geben Sie hier Ihre Nachricht ein:
                <textarea
                    type="text"
                    rows="10"
                    v-model="Contact.Message"
                    :class="!Contact.Message ? 'form-error' : null"
                    :disabled="sendStateActive"
                    :placeholder="dataPlaceholder.Message">
                </textarea>
            </div>
        </div>
        <div id="SentSuccess" class="sent-success"></div>
        <div id="SentError" class="sent-error"></div>
        <div class="button-area">
            <button
                id="SendMessageBtn"
                class="btn btn-success btn-send-message"
                :disabled="sendMessageButtonDisabled"
                @click="sendMessage()">
                <i v-if="!sendStateActive" class="fas fa-envelope" title="Nachricht senden"></i>
                <i v-else class="fas fa-cog fa-spin" title="Nachricht senden"></i>
                Nachricht senden
            </button>
            <div id="NotificationError" class="notification-checkout notification-error">
                Bitte überprüfen Sie Ihre Formulareingaben.
            </div>
        </div>
    </div>
</template>

<script>
import siteConfig from '@/assets/js/mixins/siteConfig';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    name: 'kontakt',
    mixins: [
        siteConfig
    ],
    data() {
        return {
            Contact: {
                Title: null,
                FirstName: '',
                LastName: '',
                Email: '',
                Message: ''
            },
            sendMessageButtonDisabled: false,
            title: [{
                value: null,
                text: '--'
            }, {
                value: 'Frau',
                text: 'Frau'
            }, {
                value: 'Herr',
                text: 'Herr'
            }, {
                value: 'Frau Dr.',
                text: 'Frau Dr.'
            }, {
                value: 'Herr Dr.',
                text: 'Herr Dr.'
            }, {
                value: 'Frau Dr. Dr.',
                text: 'Frau Dr. Dr.'
            }, {
                value: 'Herr Dr. Dr.',
                text: 'Herr Dr. Dr.'
            }, {
                value: 'Frau Prof.',
                text: 'Frau Prof.'
            }, {
                value: 'Herr Prof.',
                text: 'Herr Prof.'
            }, {
                value: 'Frau Prof. Dr.',
                text: 'Frau Prof. Dr.'
            }, {
                value: 'Herr Prof. Dr.',
                text: 'Herr Prof. Dr.'
            }],
            sendStateActive: false
        };
    },
    computed: {
        dataPlaceholder() {
            return {
                FirstName: 'Vorname',
                LastName: 'Nachname',
                Email: 'E-Mail-Adresse',
                Message: 'Ihre Nachricht...'
            };
        }
    },
    methods: {
        /**
         * method for validating email
         * @param email
         * @returns {boolean}
         */
        validateEmail(email) {
            let re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
            return re.test(String(email).toLowerCase());
        },

        /**
         * method for validating contact form
         * @returns {boolean}
         */
        formValidation() {
            let formValid = true;

            if (!this.Contact.Title) { formValid = false; }
            if (!this.Contact.FirstName) { formValid = false; }
            if (!this.Contact.LastName) { formValid = false; }
            if (!this.Contact.Email || !this.validateEmail(this.Contact.Email)) { formValid = false; }
            if (!this.Contact.Message) { formValid = false; }

            return formValid;
        },

        /**
         * method for sending contact message
         */
        sendMessage() {
            if (this.formValidation() === true) {
                this.emitLogData('kontakt', 'sendMessageButton');
                this.sendMessageButtonDisabled = true;
                this.sendStateActive = true;
                let request = $.ajax({
                    url: siteConfig.ajaxUrl + 'contact.php',
                    type: 'POST',
                    data: 'contactData=' + encodeURIComponent(JSON.stringify(this.Contact)),
                    dataType: 'html'
                });

                const that = this;
                request.done(function(msg) {
                    that.emitLogData('kontakt', 'messageSentOK');
                    let notification = $('#SentSuccess');
                    notification.html(msg);
                    notification.slideDown('slow');
                    that.sendStateActive = false;
                    $('#SendMessageBtn').fadeOut();
                });

                request.fail(function(jqXHR, textStatus) {
                    that.emitLogData('kontakt', 'messageSentError');
                    let notification = $('#SentError');
                    notification.html(jqXHR + '<br><br>' + textStatus);
                    notification.slideDown('slow');
                    that.sendStateActive = false;
                    $('#SendMessageBtn').fadeOut();
                });
            } else {
                let notification = $('#NotificationError');
                notification.fadeIn('slow');
                setTimeout(function() {
                    notification.fadeOut();
                }, 3400);
            }
        },
        emitLogData(page, action) {
            this.$emit(
                'log-it',
                '{"page": "' + page + '", "action": "' + action + '"}'
            );
        }
    },
    mounted() {
        this.emitLogData('kontakt', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('kontakt', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .form-item {
        padding: 0 5px 0 0;
    }
    .form-item-right {
        padding: 0 5px 0 0;
    }
    .form-item input,
    .form-item select,
    .form-item textarea,
    .form-item-left input,
    .form-item-left select,
    .form-item-right input,
    .form-item-right select {
        border: 1px solid lightgray;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        margin-bottom: 5px;
        padding: 0 5px;
    }
    .form-item-message {
        color: grey;
        margin-top: 10px;
    }
    .form-item select {
        margin-right: 4px;
    }
    .form-label {
        color: gray;
    }
    input,
    textarea {
        width: 100%;
    }
    select {
        height: 26px;
    }
    ::placeholder {
        color: lightgray;
    }
    .fas {
        margin-left: -4px;
    }
    @media only screen and (max-width: 600px) {
        input,
        select {
            height: 36px;
        }
    }
    .button-area {
        position: relative;
        margin: 10px 0 50px 0;
    }
    .sent-success,
    .sent-error {
        margin: 20px 0;
        display: none;
    }
    .select-disabled {
        background: rgb(235, 235, 228);
    }
</style>
